// ** Initial State
const initialState = {
    ProductList: [],
    loading_Product: false,
    error_Product: '',
  
    UserListAll:[],
    loading_User:false,
    error_User: ''
  }
  const adminReducer = (state = initialState, action) => {
    switch (action.type) {
      // Product
         case 'Product_LOADING': {
             return {
                 ...state,
                 loading_Product: true,
                 error_Product:''
             }
         }
         case 'Product_SUCCESS': {
             return {
                 ...state,
                 ProductList: action.data,
                 loading_Product: false
             }
         }
         case 'Product_ERROR': {
             return {
                 ...state,
                 loading_Product: false,
                 error_Product: action.error
             }
         }
  
          // All User
         case 'UserAll_LOADING': {
             return {
                 ...state,
                 loading_User: true,
                 error_User:''
             }
         }
         case 'UserAll_SUCCESS': {
             return {
                 ...state,
                 UserListAll: action.data,
                 loading_User: false
             }
         }
         case 'UserAll_ERROR': {
             return {
                 ...state,
                 UserListAll: [],
                 loading_User: false,
                 error_User: action.error
             }
         }
  
      default:
        return state
    }
  }
  
  export default adminReducer
  